import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dialog-note" }
const _hoisted_2 = {
  id: "text-error",
  class: "p-error"
}
const _hoisted_3 = { class: "dialog-footer grid mt-3" }
const _hoisted_4 = { class: "col-6 flex justify-content-center p-0" }
const _hoisted_5 = { class: "col-6 flex justify-content-center p-0" }

import Textarea from "primevue/textarea";
import { ref } from "vue";
import { set, get } from "@vueuse/core";


export default /*#__PURE__*/_defineComponent({
  __name: 'dialog-note',
  emits: ["close", "save"],
  setup(__props, { expose, emit: emits }) {


const visible = ref<boolean>(false);
const content = ref("");
const onShow = (contentVal: string) => {
  set(content, contentVal);
  set(visible, true);
};
const errorMessage = ref<string>("");
const validateNote = () => {
  errorMessage.value = "";
  if (get(content).trim() == "") {
    errorMessage.value = "メモを入力してください。";
    return;
  }
  if (get(content).length > 300) {
    errorMessage.value = "300文字以下にしてください。";
    return;
  }
};
const onClosedDialog = () => {
  set(visible, false);
  set(content, "");
  set(errorMessage, "");
  emits("close");
};

const onSaveNote = () => {
  validateNote();
  if (errorMessage.value !== "") return;
  set(visible, false);
  emits("save", get(content));
};
// eslint-disable-next-line no-undef
expose({
  onShow,
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Dialog, {
      visible: visible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
      modal: "",
      header: '顧客メモを追加',
      style: { width: '550px' },
      class: "mx-5 dialog-note border-0",
      draggable: false,
      onHide: onClosedDialog
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Textarea), {
          modelValue: content.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((content).value = $event)),
          "aria-describedby": "description-help",
          type: "text",
          size: "large",
          name: "note",
          rows: "10",
          cols: "30",
          class: _normalizeClass(["textarea-note", { 'p-invalid': errorMessage.value }]),
          placeholder: "顧客の情報を追加できます。メモの情報は相手には公開されません。"
        }, null, 8, ["modelValue", "class"]),
        _createElementVNode("small", _hoisted_2, _toDisplayString(errorMessage.value || " "), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Button, {
              label: "キャンセル",
              class: "p-button-light w-100",
              onClick: onClosedDialog
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              class: "w-100",
              label: "保存",
              onClick: onSaveNote
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})